import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  currencyImage: {
    height: theme.spacing(15),
    width: theme.spacing(15),
  },
  currencyContainer: {
    display: "flex",
    alignItems: "center",
    width: theme.spacing(120),
  },
  currencyText: {
    margin: theme.spacing(0, 3),
  },
  currencySelect: {
    display: "flex",
    alignItems: "center",
    width: theme.spacing(150),
  },
}));
